<template>
  <v-sheet height="100%">
    <slide1 />
    <v-dialog v-model="modalBoolean" width="85%">
      <v-card>
        <v-app-bar dark color="primary" :fixed="true">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modalBoolean = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="text-center"
              v-if="clickedItem.name === 'TV' && modalBoolean"
            >
              <iframe
                width="100%"
                height="600"
                src="https://www.youtube.com/embed/wVSfcn5n7-E"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </v-col>
            <v-col
              cols="12"
              class="text-center"
            >
              <v-img
                v-for="asset in clickedItem.assets"
                :key="asset"
                :src="renderImage(asset)"
                eager
              >
              </v-img>
            </v-col>
            <v-col
              cols="12"
              class="text-center"
              v-if="clickedItem.name === 'Easel2'"
            >
              <viewer
                :images="designImages"
                :options="viewerOptions"
                class="images clearfix"
              >
                <template slot-scope="scope">
                  <v-row justify="center">
                    <v-col
                      v-for="obj in scope.images"
                      :key="obj.src"
                      class="d-flex child-flex"
                      :cols="mobileCol"
                    >
                      <v-hover v-slot:default="{ hover }">
                        <v-card
                          :elevation="hover ? 12 : 2"
                          :class="{ 'on-hover': hover }"
                        >
                          <v-card-title
                            v-html="obj.name"
                            class="justify-center"
                          >
                            {{ obj.name }}
                          </v-card-title>
                          <img :src="obj.src" class="image" />
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </template>
              </viewer>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import slide1 from "../../public/static/Slide 1/VirgilLangford.svg";
import svgMixin from "@/mixins/svgMixin.js";
import "viewerjs/dist/viewer.css";
// import Viewer from "v-viewer/src/component.vue";

export default {
  name: "BethlehemRoad",
  components: {
    slide1,
    // Viewer
  },
  mixins: [svgMixin(2, ".slide1", "slide1.js")],
  data() {
    return {
      // Raw html here to avoid ugly text wrapping
      designImages: [
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-0.jpg",
          name: "North Springs to <br>Spalding Drive"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-1.jpg",
          name: "Pitts Road to <br>Northridge Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-2.jpg",
          name: "Roberts Drive to <br>Chattahoochee River"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-3.jpg",
          name: "Holcomb Bridge Road to <br>Mansell Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-4.jpg",
          name: "Mansell Road to <br>Encore Parkway"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-5.jpg",
          name: "Haynes Bridge Road to <br>Old Milton Parkway"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-6.jpg",
          name: "Webb Bridge Road to <br>Windward Parkway"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-7.jpg",
          name: "McGinnis Ferry Road to <br>Union Hill Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/rollplots-8.jpg",
          name: "McFarland Road to <br>Big Creek"
        }
      ],
      bridgeImages: [
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/SandySprings.jpg",
          name: "Sandy Springs"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/Roswell.jpg",
          name: "Roswell"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/sr400/design/Alpharetta.jpg",
          name: "Alpharetta"
        }
      ],
      viewerOptions: {
        title: false
      },
      modalBoolean: false,
      clickedItem: "",
      mouseOverIndex: null,
      showImgModal: false
    };
  },
  computed: {
    mobileCol() {
      if (this.$vuetify.breakpoint.mobile) return "12";
      return 4;
    }
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    },
    openModalAndPassIndex(index) {
      this.mouseOverIndex = index;
      this.showImgModal = true;
    },
    closeModalAndNullIndex() {
      this.mouseOverIndex = null;
      this.showImgModal = false;
    },
  }
};
</script>

<style>
.mouse {
  cursor: pointer !important;
}
</style>
